(function () {
  var requiredKeys = ['Perfume 1', 'Perfume 2', 'Engraving Text', 'Font Style'];
  var debounceTimer = null;
  var DEBOUNCE_DELAY = 400; // ms to wait after the last trigger before actually fetching

  function getCheckoutButton() {
    return document.querySelector('.rebuy-cart__checkout-button[data-gokwik-function="checkout"]');
  }

var FUSION_KEYS = ['Perfume 1', 'Perfume 2'];
var PERSONALIZED_KEYS = [['Engraving Text', 'Text for Engraving'], 'Font Style'];

function getRequiredKeys(item) {
  var isFusion = item.handle === 'fusion';
  var isPersonalized = item.variant_title === '100ml Personalized';

  if (isFusion) {
    // 50ml / 100ml  → 2 perfumes
    // 100ml Personalized → all 4
    return isPersonalized ? FUSION_KEYS.concat(PERSONALIZED_KEYS) : FUSION_KEYS;
  }

  // Default product: only 100ml Personalized needs anything
  return isPersonalized ? PERSONALIZED_KEYS : [];
}

function validateFusionItems(cart) {
  var missing = [];

  cart.items.forEach(function (item, index) {
    var requiredKeys = getRequiredKeys(item);
    if (!requiredKeys.length) return; // default product, non-personalized

    var properties = item.properties || {};

    requiredKeys.forEach(function (key) {
      var names = [].concat(key); // string, or list of accepted names
      var hasValue = names.some(function (name) {
        var value = properties[name];
        return value !== undefined && value !== null && String(value).trim() !== '';
      });

      if (!hasValue) {
        missing.push('Item ' + (index + 1) + ' (' + item.product_title + '): ' + names[0]);
      }
    });
  });

  return missing;
}
  

  function showMessage(button, missing) {
    var existing = document.querySelector('[data-fusion-checkout-error]');
    if (existing) existing.remove();

    if (!missing.length) return;

    var message = document.createElement('div');
    message.setAttribute('data-fusion-checkout-error', '');
    message.setAttribute('role', 'alert');
    message.className = 'alert alert--error text-sm font-medium leading-tight';
    message.textContent = 'Please complete: ' + missing.join(', ') + '.';
    button.parentNode.insertBefore(message, button);
  }

  // The actual fetch + validate logic, unchanged in behavior
  function runCheckoutValidation() {
    var button = getCheckoutButton();
    if (!button) return;

    fetch('/cart.js', { credentials: 'same-origin' })
      .then(function (response) { return response.json(); })
      .then(function (cart) {
        var missing = validateFusionItems(cart);

        if (missing.length) {
          button.disabled = true;
          button.classList.add('is-disabled'); // optional: for custom greyed-out styling
          showMessage(button, missing);
          console.warn('[Fusion checkout] Button disabled — missing:', missing);
        } else {
          button.disabled = false;
          button.classList.remove('is-disabled');
          showMessage(button, []);
          console.info('[Fusion checkout] Button enabled — all Fusion items valid');
        }
      })
      .catch(function (error) {
        console.warn('[Fusion checkout] Could not validate cart', error);
      });
      cart.items.forEach((item, index) => {
      console.log(`Item ${index + 1}: ${item.product_title} — ${item.variant_title}`);
      console.table(item.properties || {});
    });
  }

  // Debounced entry point: every trigger resets the timer, so only the LAST
  // call within DEBOUNCE_DELAY ms actually results in a fetch.
  function refreshCheckoutState() {
    clearTimeout(debounceTimer);
    debounceTimer = setTimeout(runCheckoutValidation, DEBOUNCE_DELAY);
  }

  // Re-check whenever the cart or product form might have changed.
  // Even if several of these fire within milliseconds of each other
  // (common with Vue-rendered cart widgets), the debounce collapses
  // them into a single fetch.
  document.addEventListener('DOMContentLoaded', refreshCheckoutState);
  document.addEventListener('variant:change', refreshCheckoutState);
  document.addEventListener('cart:updated', refreshCheckoutState);   // fires on many themes after add/remove/update
  document.addEventListener('cart:refresh', refreshCheckoutState);   // some Rebuy setups use this
  document.addEventListener('rebuy:cart.change', refreshCheckoutState); // Rebuy-specific event, if it exists

  // NOTE: setInterval fallback removed. Once you confirm (via the console
  // event-sniffer snippet) which real cart-change event your theme fires,
  // this event-driven + debounced approach should be enough on its own.
  // If you still see stale button states in testing, that means NONE of the
  // events above are firing reliably — tell me and we'll add back a much
  // longer-interval fallback (e.g. every 10-15s) rather than 3s.
})();